import DocumentManagementScreen from "../DocumentManagementScreen/DocumentManagementScreen";

function DocumentManagement(props) {
  const { userInfo } = props;
  return <DocumentManagementScreen userInfo={userInfo} />;
}

export default DocumentManagement;
